var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEditing)?_c('Icon',{staticStyle:{"font-size":"60px"},attrs:{"type":"md-share"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }